module.exports = __webpack_public_path__ + "static/media/health-full-width.e6783ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/health-full-width.png
// module id = 839
// module chunks = 0